"use client"
import React, { useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Import default styles for the phone input
import { Button } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify'; // For success/error messages
import 'react-toastify/dist/ReactToastify.css'; // Import Toast styles
import ReCAPTCHA from 'react-google-recaptcha';
import Loader from '../components/Loader';

const ExpertForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [phone, setPhone] = useState('');
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [recaptchaValue, setRecaptchaValue] = useState<string | null>(null);
  const [errors, setErrors] = useState<{ fullname?: string; email?: string; phone?: string; message?: string; }>({});
  const [submitted, setSubmitted] = useState(false);

  const handleRecaptchaChange = (value : string | null) => {
    setRecaptchaValue(value);
  };

  // Validation function
  const validateForm = () => {
    const newErrors: { fullname?: string; email?: string; phone?: string; message?: string } = {};
    if (!fullname) {
      newErrors.fullname = 'Full Name is required';
    }else if (fullname.length > 60) {
      newErrors.fullname = 'Fullname must be less than 60 characters.';
    }
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    if (!phone) {
      newErrors.phone = 'Phone number is required';
    }else if(phone.length <10 || phone.length > 18){
      newErrors.phone = 'Please phone number between 10 to 18 digit';
    }
    if (!message) {
      newErrors.message = 'Message is required';
    }else if (message.length > 200) {
      newErrors.message = 'Message must be less than 200 characters.';
    }
    if (!recaptchaValue) {
      return;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitted(true); // Set submitted to true
    setLoading(true);
    if (validateForm()) {
      // Simulating API call (replace with actual API logic)
      try {
        // Simulate an API call
        const response = await fetch('/api/expert', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            fullname,
            email,
            phone,
            message,
            recaptcha_token: recaptchaValue,
          }),
        });
        const data = await response.json();
        console.log(data);
        if(data.success == true){
          // Show success toast
          toast.success(data.message);
          setFullname('');
          setEmail('');
          setPhone('');
          setMessage('');
          setRecaptchaValue('');
          setSubmitted(false);
        }else{
            setRecaptchaValue('');
            recaptchaRef.current?.reset();
          toast.error(data.message);
        }
      } catch (error) {
        setRecaptchaValue('');
        recaptchaRef.current?.reset();
        const message = error instanceof Error ? error.message : String(error);
        toast.error(message);
      }
      setLoading(false);
    }else{
      setLoading(false);
    }
  };

  // Handle input change (clear errors when user types)
  const handleInputChange = (field: string, value: string) => {
    if (submitted) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: '', // Clear error for the specific field
      }));
    }
    if (field === 'fullname') setFullname(value);
    if (field === 'email') setEmail(value);
    if (field === 'phone') setPhone(value);
    if (field === 'message') setMessage(value);
    if (field === 'message') setMessage(value);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="loginForm0 ">
        <form method="post" action="/adduser" name="createaccount" id="createaccount2" onSubmit={handleSubmit}>
          <input type="hidden" name="_token" value="OsrLJoeT1egzpaioSEvESzJStuBLFBMtkXax8y54" />
          <h4 className="textHad h2 text-center fw-bold mb-2">30 Minutes Free Consultation</h4>
          
          {/* Full Name */}
          <div className="my-4">
            <div className="input-group input-group-lg p-0 rounded-2 custInput">
              {/* <span className="input-group-text custIcon" id="inputGroup-sizing-lg">
                <FontAwesomeIcon icon={faUser} className="textOrange fs-3" />
              </span> */}
              <input
                type="text"
                name="fullname"
                className="form-control"
                placeholder="Enter your full name"
                aria-label="Enter your full name"
                value={fullname}
                onChange={(e) => handleInputChange('fullname', e.target.value)} // Handle change
              />
            </div>
            {errors.fullname && submitted && <div className="text-danger mt-2">{errors.fullname}</div>}
          </div>

          {/* Email */}
          <div className="my-4">
            <div className="input-group input-group-lg p-0 rounded-2 custInput">
              {/* <span className="input-group-text custIcon" id="inputGroup-sizing-lg">
                <FontAwesomeIcon icon={faEnvelope} className="textOrange fs-3" />
              </span> */}
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter your email"
                aria-label="Enter your email"
                value={email}
                onChange={(e) => handleInputChange('email', e.target.value)} // Handle change
              />
            </div>
            {errors.email && submitted && <div className="text-danger mt-2">{errors.email}</div>}
          </div>

          {/* Phone Number with Flags */}
          <div className="my-4">
            <div className="custInput p-0">
              <PhoneInput
                country={'us'} // Default country
                value={phone}
                onChange={(value) => handleInputChange('phone', value)} // Updates the state on input change
                inputClass="form-control custInput"
                containerClass="phone-input-container" 
                inputStyle={{
                  width: '100%',
                  borderRadius: '8px',
                  height: '70px',
                  paddingLeft: '100px', // Adjust padding for flag
                }}
              />
            </div>
            {errors.phone && submitted && <div className="text-danger mt-2">{errors.phone}</div>}
          </div>

          {/* Message */}
          <div className="my-4">
            <div className="input-group input-group-lg p-0 rounded-2 custInput">
              <textarea
                name="message"
                className="form-control"
                placeholder="Enter your message"
                rows={2}
                value={message}
                onChange={(e) => handleInputChange('message', e.target.value)} // Handle change
              ></textarea>
            </div>
            {errors.message && submitted && <div className="text-danger mt-2">{errors.message}</div>}
          </div> 
          
          <div className="my-4">
            <ReCAPTCHA
              sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
              onChange={handleRecaptchaChange}
              ref={recaptchaRef}
            />
          </div>
          
          {!recaptchaValue && submitted && <div className="my-4 d-flex"><div className="text-danger mt-2">Please verify that you are not a robot.</div></div>}

          <input type="hidden" name="recaptcha_token" id="recaptcha_token" value={recaptchaValue || ''} />
          
          <div className="d-grid gap-2 mb-3">
            <Button variant="primary" size="lg" type="submit">
              Submit Now!
            </Button>
          </div>
        </form>
        <ToastContainer />
      </div>
    </>
  );
};

export default ExpertForm;
